import queryString from 'query-string';

export const conversationIdFromSearch = (search) => {
  const { session } = queryString.parse(search);
  return typeof session === 'string' && session ? session : null;
};

export const conversationsUrl = (pathname, chatSessionId, section) =>
  `${pathname}?${queryString.stringify({ tab: 'conversations', session: chatSessionId || undefined, section })}`;

export const ANSWER_TYPES = {
  products: { label: 'Products', color: 'success' },
  qa: { label: 'Q&A', color: 'info' },
  order: { label: 'Order', color: 'gray' },
  unanswered: { label: 'Unanswered', color: 'warning' },
};

export const ANSWER_TYPE_FILTERS = [
  { value: '', label: 'All answers' },
  ...Object.entries(ANSWER_TYPES).map(([value, { label }]) => ({ value, label })),
];

// Shopper votes on agent replies (the feedback row); the list filters by `vote`.
export const VOTE_FILTERS = [
  { value: '', label: 'All' },
  { value: 'up', label: 'With 👍' },
  { value: 'down', label: 'With 👎' },
];

export const shopperName = (shopper) => {
  const fullName = [shopper?.firstName, shopper?.lastName].filter(Boolean).join(' ');
  return fullName || shopper?.email || shopper?.phoneNumber || null;
};

export const shopperLabel = (shopper) =>
  shopperName(shopper) || (shopper?.visitorId ? `User ${shopper.visitorId}` : 'Anonymous visitor');

export const profileHref = (accountId, domainId, profileId) =>
  profileId ? `#/accounts/${accountId}/domains/${domainId}/profiles/${encodeURIComponent(profileId)}/events` : null;

const TRACKING_PARAMS = ['releva_chat', 'rlv_said', 'rlv_sapid'];

export const withoutTrackingParams = (url) => {
  try {
    const parsed = new URL(url);
    if (!TRACKING_PARAMS.some((param) => parsed.searchParams.has(param))) return url;
    for (const param of TRACKING_PARAMS) parsed.searchParams.delete(param);
    return parsed.toString();
  } catch {
    return url;
  }
};

export const formatPrice = (amount, currency) => {
  if (amount === null || amount === undefined) return null;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
  } catch {
    return `${Number(amount).toFixed(2)}${currency ? ` ${currency}` : ''}`;
  }
};

const dayLabel = (date) =>
  date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() !== new Date().getFullYear() && { year: 'numeric' }),
  });

const timeLabel = (date) => date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

export const formatListDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return `${dayLabel(date)}, ${timeLabel(date)}`;
};

export const formatMessageTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return `${timeLabel(date)} • ${dayLabel(date)}`;
};

const PRODUCT_FEED_RE = /<productfeed\b((?:[^>"]|"[^"]*")*?)(?:\/>|>[\s\S]*?<\/productfeed>)/gi;
const QUESTION_RE = /<question(?:\s+visual="([^"]*)")?\s*>([\s\S]*?)<\/question>/gi;
const STATE_RE = /<state>[\s\S]*?<\/state>/gi;
const TITLE_ATTRIBUTE_RE = /\btitle="([^"]*)"/i;

export const parseAssistantText = (raw) => {
  const productFeeds = [];
  const suggestions = [];
  const text = (raw || '')
    .replace(PRODUCT_FEED_RE, (_match, attributes) => {
      productFeeds.push(attributes.match(TITLE_ATTRIBUTE_RE)?.[1] || 'Recommended Products');
      return '';
    })
    .replace(QUESTION_RE, (_match, visual, prompt) => {
      const instruction = (prompt || '').trim();
      suggestions.push((visual || instruction).trim());
      return '';
    })
    .replace(STATE_RE, '')
    .trim();

  return { text, productFeeds, suggestions };
};
